import React from 'react';
import Callout from './callout';
export default function index({ bodyCopy }) {
  return (
    <Callout calloutTitle="You Might Be Eligible for Savings" buttonTitle="See If You Are Eligible" buttonLink="/paying-for-aveed/" bodyCopy={bodyCopy}>
      <p>If you have been prescribed AVEED<sup>&reg;</sup>, you may be eligible for savings with the AVEED<sup>®</sup> Copay Assistance Program.</p>
    </Callout>
  )
}
